import * as React from 'react';
import { Badge } from '@liveauctioneers/hammer-ui-core/badge';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { Eye, Pause, VideoCamera } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { LabelStrong } from '@liveauctioneers/hammer-ui-core/text';

type Props = {
    className?: string;
    hasVideo?: boolean;
    myItemsSavedItemsCard?: boolean;
    pause?: boolean;
    viewers: number;
};

const ConsoleSocialBadge = ({ className = '', hasVideo, myItemsSavedItemsCard, pause, viewers = 1 }: Props) => {
    return (
        <Badge
            className={cn('z-[2] flex items-center justify-center gap-xs', className)}
            color="critical"
            data-testid="console-social-badge"
            emphasis="bold"
            size="sm"
        >
            {!pause && hasVideo && (
                <VideoCamera
                    className=""
                    size="sm"
                    style="fill"
                />
            )}
            {pause && (
                <Pause
                    size="sm"
                    style="fill"
                />
            )}
            <LabelStrong className="uppercase text-text-inverse">
                {pause && <FormattedMessage id="paused" />}
                {!pause && !myItemsSavedItemsCard && <FormattedMessage id="live" />}
            </LabelStrong>
            <Eye size="sm" />
            <LabelStrong className="text-text-inverse">{viewers}</LabelStrong>
        </Badge>
    );
};

export default React.memo<Props>(ConsoleSocialBadge);
